export default {
  async sendApiRequest(url, method, setauth, body) {
    const requestOptions = {
      method: method,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(body),
    };
    if (method === "DELETE") {
      delete requestOptions.body;
    }
    if (method === "GET") {
      delete requestOptions.body;
    }

    if (setauth === true) {
      let token = window.user ? window.user.token : "no-token";
      requestOptions.headers["Authorization"] = token;
    }
    try {
      const response = await fetch(window.apiurl + url, requestOptions);
      let body = await response.text();
      if (response.status === 401 && JSON.parse(body).status === 401) {
        localStorage.removeItem("user");
        localStorage.removeItem("lastActivityTime");
        window.user = null;
        window.location.hash = "#/login";
        throw body;
      }
      if (response.status != 200) {
        throw body;
      }
      const data = JSON.parse(body);
      return data;
    } catch (e) {
      throw e;
    }
  },
};

export function getCurrency() {
  if (window.location.hostname.includes(".com")) {
    return "USD";
  } else {
    return "GBP";
  }
}
